// Brand assets are served from our own origin (frontend/public/brand/) —
// nothing is loaded from a third-party host.
export const LOGO_URL = "/brand/logo.webp";
// The same three cards cut out of their tile, with their shadow, to sit
// directly on a page background. 760 × 657: size it by height, width auto.
export const EMBLEM_URL = "/brand/emblem.webp";
export const BG_URL = "/brand/background.svg";
// The same backdrop composed for a phone held upright.
export const BG_PORTRAIT_URL = "/brand/background-portrait.svg";
// The game's dealer, by language: in Tunisian he is القهواجي, the café waiter (red chechia,
// a tray with a coffee: drawn as an SVG); in French and English, the robot.
export const dealerAvatar = (lang) => (lang === "tn" ? "/brand/qahwaji.svg" : "/chatBot.jpg");
